import {API} from 'aws-amplify';

export const read = async () => API.get('robinhoodEngUserApi', '/subscriptions', {});

export const del = async (subscription) =>
  API.del('robinhoodEngUserApi', `/subscriptions/${subscription.id}`, {body: {}});
